import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { PriceDisplay } from './PriceDisplay';
import { CheckCircle2, Lock, Zap } from 'lucide-react';
export const FinalOffer = () => {
  const includes = ['Curso completo paso a paso', 'Plantillas Instagram Aesthetic', 'Guía: Primeras 10 clientas', 'Lista de proveedores premium', 'Entrenamiento de mentalidad', 'Recetario de velas rentables', 'Acceso inmediato y de por vida', 'Soporte y comunidad privada'];
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-51">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-52">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-accent-rose/20 blur-3xl" data-id="element-53" />
      </div>

      <div className="max-w-4xl mx-auto px-6" data-id="element-54">
        <FadeIn className="text-center mb-10" data-id="element-55">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-rose text-text-dark text-xs font-bold uppercase tracking-widest" data-id="element-56">
            <Zap className="w-4 h-4" data-id="element-57" /> Oferta por tiempo limitado
          </span>
        </FadeIn>

        <FadeIn delay={0.1} className="bg-white rounded-[2.5rem] p-6 md:p-12 shadow-2xl border border-white/50 relative overflow-hidden" data-id="element-58">
          <div className="text-center mb-10" data-id="element-59">
            <h2 className="text-3xl md:text-5xl mb-3 leading-tight" data-id="element-60">
              Método Emprendimiento{' '}
              <span className="italic text-accent-rose-deep" data-id="element-61">Aesthetic™</span>
            </h2>
            <p className="text-base md:text-lg text-text-brown/70" data-id="element-62">
              Todo lo que necesitás para empezar hoy.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:gap-10 items-center mb-6" data-id="element-63">
            <div data-id="element-64">
              <h3 className="font-bold text-base uppercase tracking-wider mb-5 text-text-brown/60 border-b border-nude pb-3" data-id="element-65">
                Tu inscripción incluye
              </h3>
              <ul className="space-y-3" data-id="element-66">
                {includes.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-67">
                    <CheckCircle2 className="w-5 h-5 text-accent-rose-deep shrink-0" data-id="element-68" />
                    <span className="text-text-brown font-medium text-sm md:text-base" data-id="element-69">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-nude/40 p-6 md:p-8 rounded-3xl text-center border border-beige/50" data-id="element-70">
              <div className="mb-3" data-id="element-71">
                <span className="block text-xs text-text-brown/60 uppercase tracking-wider mb-1" data-id="element-72">
                  Antes
                </span>
                <PriceDisplay amountARS={49000} strikeThrough className="text-text-brown/60 text-lg" data-id="element-73" />
              </div>

              <div className="my-5 h-px bg-beige" data-id="element-74" />

              <div className="mb-6" data-id="element-75">
                <span className="block text-xs font-bold text-accent-rose-deep uppercase tracking-widest mb-2" data-id="element-76">
                  Hoy pagás solo
                </span>
                <PriceDisplay amountARS={15000} className="text-5xl md:text-6xl font-serif font-bold text-text-dark block leading-none" data-id="element-77" />
                <span className="block text-xs text-text-brown/60 mt-2" data-id="element-78">
                  Pago único · Sin cuotas ocultas
                </span>
              </div>

              <Button fullWidth className="mb-4" data-id="element-79">
                QUIERO EMPEZAR HOY
              </Button>

              <div className="flex items-center justify-center gap-2 text-xs text-text-brown/60 mt-3" data-id="element-80">
                <Lock className="w-3.5 h-3.5" data-id="element-81" />
                <span data-id="element-82">Pago 100% seguro y encriptado</span>
              </div>
            </div>
          </div>

          <div className="text-center pt-6 border-t border-nude/60" data-id="element-83">
            <p className="text-sm text-text-brown/70 italic" data-id="element-84">
              ✨ Acceso inmediato al inscribirte. Empezás a aprender en menos de
              5 minutos.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};